import React from "react";
import { StatsDisplayPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const StatsDisplayPage: React.FC<Props> = ({ page, onNext }) => {
  return (
    <div className="page page--stats-display">
      <div className="page__container">
        <div className="stats-grid">
          {page.stats.map((stat, index) => (
            <div key={index} className="stat-card">
              {stat.icon && (
                <span className="stat-card__icon">{stat.icon}</span>
              )}
              <h3 className="stat-card__number">{stat.number}</h3>
              <p className="stat-card__label">{stat.label}</p>
            </div>
          ))}
        </div>

        {page.image && (
          <img src={page.image} alt="Stats" className="stats__image" />
        )}

        <button className="page__button" onClick={onNext}>
          {page.buttonText}
        </button>
      </div>
    </div>
  );
};

export default StatsDisplayPage;
